import Mustache from "mustache";

var showingSearchResults = false;

$(function () {
  if ($("#support-download-holder").length > 0) {
    initDownloadViewer();
  }
});

function initDownloadViewer() {
  $("#dl_filter").on("click", "li a", function (e) {
    console.log("CLICKED");
    e.preventDefault();

    var d = new Date();
    var n = d.getTime();

    var column = $(this).parents(".dl-col").attr("id");
    var param = "timestamp=" + n;
    var dest = "";

    $("#" + column)
      .find("li a")
      .removeClass("on");
    $(this).addClass("on");

    switch (column) {
      case "dl_cats":
        param = param + "&type=dl_cats&id=" + $(this).attr("id");
        $("#dl_holder").fadeOut();
        $("#dl_types").html("");
        $("#dl_products").html("");
        $("#dl_filetypes").html("");

        dest = "dl_types";
        break;

      case "dl_types":
        param = param + "&type=dl_types&id=" + $(this).attr("id");
        $("#dl_holder").fadeOut();
        $("#dl_products").html("");
        $("#dl_filetypes").html("");
        dest = "dl_products";
        break;

      case "dl_products":
        param = param + "&type=dl_products&id=" + $(this).attr("id");
        $("#dl_holder").fadeOut();
        $("#dl_filetypes").html("");
        dest = "dl_filetypes";
        break;

      case "dl_filetypes":
        param =
          param +
          "&type=dl_filetypes&id=" +
          $(this).attr("id") +
          "&owner_id=" +
          $("#dl_products ul li a.on").attr("id");
        break;

      default:
        console.log("Unknown column: " + column);
    }

    setLoader(dest);
    getList(param, dest);
  });

  //On load, return all available categories
  getList("", "dl_cats");

  $("#fileSearch").keyup(function (e) {
    if (e.which === 13) {
      submitSearch();
    }
    if ($(this).val().length > 0) {
      $("#btn-fileSearch").removeAttr("disabled");
    } else {
      $("#btn-fileSearch").attr("disabled", "disabled");
    }
  });

  $("#btn-fileSearch").click(function (e) {
    submitSearch();
  });

  $("#btn-fileClear").click(function (e) {
    showingSearchResults = false;
    setLoader("dl_cats");
    getList("", "dl_cats");
    $("#filterPane").slideDown();
    $("#dl_holder").fadeOut();
    $("#btn-fileClear").attr("disabled", "disabled");
  });
}

function setLoader(dest) {
  if (dest !== "") {
    $("#" + dest).html(
      '<div class="spinner"><img src="/assets/images/spinner.svg" alt="Loading" name="loader" /></div>'
    );
  }
}

function hideLoader() {
  $("img[name='loader']").fadeOut("fast", function () {
    $(this).remove();
  });
}

function submitSearch() {
  showingSearchResults = true;
  $("#filterPane").slideUp();
  $("#btn-fileClear").removeAttr("disabled");

  var d = new Date();
  var n = d.getTime();
  var param =
    "timestamp=" + n + "&type=dl_filetypes&search=" + $("#fileSearch").val();
  getList(param, "");
}

//param = data to send to ajax script
//dest = destination column to populate
function getList(param, dest) {
  param = param || "";
  $.ajax({
    url: "/ajax/downloads",
    type: "get",
    data: param,
    success: function (data) {
      //console.log(data);
      if (dest !== "") {
        var output = Mustache.render(
          '<ul>{{#.}}<li><a href="#" id="{{id}}"><span>{{name}}<span></a></li>{{/.}}</ul>',
          data
        );
        $("#" + dest).html(output);
      } else {
        var output;
        if (data.length === 0) {
          output =
            '<div class="alert alert-info"><strong>No downloads were found for your search term.</strong></div>';
        } else {
          output = Mustache.render(
            `
                        {{#.}}<tr class="dl-item">
                            <td data-type="Type:">{{type}}</td>
                            <td data-type="Title:">{{title}}</td>
                            <td data-type="File Size:">{{filesize}}</td>
                            <td data-type="Created On:">{{created_on}}</td>
                            <td class="download-cell">
                                <a href="/assets/files/{{filename}}.{{filetype}}" download="{{filename}}.{{filetype}}" target="_blank" class="btn btn-outline-cta">Download</a> 
                            </td>
                        </tr>{{/.}}
                    `,
            data
          );
        }
        $("#dl_holder .dl-items").html(output);
        $("#dl_holder").fadeIn();
      }
    },
  });
}
